import { _ as t } from "../internals/export.js";
import { s as r } from "../internals/string-trim-start.js";
t({
  target: "String",
  proto: !0,
  name: "trimStart",
  forced: "".trimLeft !== r
}, {
  trimLeft: r
});